// const config = {
//   username: '',
//   password: '',
//   neo4j_database: null,
//   neo4j_user: 'neo4j',
//   neo4j_uri: 'neo4j+s://489b0fdd.databases.neo4j.io:7687',
//   neo4j_password: 'o2qvt7fhw0-XWFveOkLVBUaNwj03AT_tBHy60ptGJ_U'
// };

const config = {
  username: '',
  password: '',
  neo4j_database: "sbd.explorationbscproject",
  neo4j_user: 'demo_sbd_explorationbscproject',
  neo4j_uri: 'neo4j+s://metal.graphpolaris.com:8012',
  neo4j_password: 'zPnD8412&4%LQTDz'
};

export default config;